import namespace from './namespace';

const config = {
    baseUrl: `https://${namespace}-api.ext.dev.bizzabo.com`,
    authCookieAccess: `x-bz-access-attendee-token-${namespace}`,
    eventsUrl: `https://${namespace}-events.ext.dev.bizzabo.com`,
    previewCookieName: 'x-bz-preview',
    cloudinaryCloudName: 'bizzabo',
    cloudinaryUploadPreset: 'n4w6z5xg',
    snowplowDevelopmentEndpoint: 'com-bizzabo-prod1.mini.snplow.net',
    snowplowProductionEndpoint: 'sp.bizzabo.com',
    snowplowSourceEndpoint: 'https://cdnjs.cloudflare.com/ajax/libs/snowplow/2.16.3/sp.js',
    getStreamKey: 'a6jhg2fnjfac',
    environment: 'development',
};

export default config;
